/** Warrants page copy. EN mirrors SV until translated. */
export const pagesWarrantsSv = {
    filters: {
        onlyInTheMoney: 'Visa enbart TO in the money',
        onlyOutOfTheMoney: 'Visa enbart TO out of the money',
        onlyFloatingPrice: 'Visa enbart TO med rörlig kurs',
        onlyFixedPrice: 'Visa enbart TO med fast kurs',
        unlistedLabel: 'Onoterade',
        inTheMoneyLabel: 'In the money',
    },
    status: {
        label: 'Status:',
        cancelled: 'Avbruten',
        upcoming: 'Kommande',
        completed: 'Genomförd',
        ongoingSubscription: 'Pågående inlösenperiod',
    },
    cancelledNotice:
        'Notera att denna teckningsoption är avbruten. Innehållet som återges nedan återspeglar den information som fanns tillgänglig för marknaden.',
    sections: {
        origin: 'Optionens ursprung',
        terms: 'Villkor',
        subscribersAndGuarantors: 'Tecknings- och garantiåtagare',
        outcome: 'Utfall',
        tradingStats: 'Handelsstatistik',
        other: 'Övrigt',
    },
    summary: {
        title: 'Sammanfattning',
    },
    firstTradingDay: 'Första handelsdag',
    tradingNotStarted: 'Handel ej inledd',
    unlisted: 'Onoterat',
    lastSubscriptionDay: 'Sista teckningsdag',
    subscriptionPeriod: 'Teckningsperiod',
    ratio: 'Ratio',
    currentSharePrice: 'Aktuell aktiekurs',
    amountAtFullUtilization: 'Belopp vid full nyttjandegrad',
    pricing: 'Prissättning',
    secured: 'Säkerställd',
    subscriptionCommitment: 'Teckningsåtagande:',
    guarantorCommitment: 'Garantiåtagande:',
    shareSingular: 'aktie',
    sharePlural: 'aktier',
    warrantSingular: 'TO',
    warrantPlural: 'TO',
    preliminaryOneDay: '* Preliminärt baserat på senaste handelsdagen',
    preliminaryDays: '* Preliminärt baserat på de senaste {{n}} handelsdagarna',
    noSubscriptionPeriods: 'Inga underliggande perioder hittades',
    showingPeriod: 'Visar period {{current}} av totalt {{total}} teckningsperioder.',
    guarantorRemunerationShares: 'Ersättning i aktier till garanter',
    origin: {
        label: 'Ursprung',
        numberOfWarrants: 'Antal optioner',
    },
    tradingStats: {
        columns: {
            time: 'Tidpunkt',
            vwap: 'VWAP',
            tradedCount: 'Antal omsatta',
            tradedShare: 'Andel omsatta',
            turnoverPerDay: 'Omsättning / dag',
        },
        sinceTradingStarted: 'Sedan handel inleddes',
        lastTenDays: 'Senaste tio handelsdagarna',
        latestDay: 'Senaste handelsdagen',
    },
    otherInfo: {
        priceAdjustment:
            'Vid eventuella nyemissioner innan teckningsperiodens start ska teckningskursen justeras till emissionskursen.',
    },
}
